import { loadSwiper } from './swiper-loader'

// Sätts av loadSwiper() innan någon slider instansieras.
let Swiper, Navigation, Scrollbar, Autoplay, EffectFade

function buildOptions(swiperCarousel) {
    const options = {
        modules: [Navigation, Scrollbar, Autoplay],
        navigation: {
            nextEl: swiperCarousel.parentElement.querySelector('.swiper-button-next'),
            prevEl: swiperCarousel.parentElement.querySelector('.swiper-button-prev'),
        },
        scrollbar: {
            el: swiperCarousel.parentElement.querySelector('.swiper-scrollbar'),
            draggable: true,
        },
        speed: 500,
    }

    if (swiperCarousel.dataset.slider_breakpoints) {
        try {
            options.breakpoints = JSON.parse(swiperCarousel.dataset.slider_breakpoints)
        } catch (err) {
            console.error('Invalid data-slider_breakpoints JSON', err, swiperCarousel)
        }
    }

    if (swiperCarousel.dataset.slider_autoplay === 'true') {
        options.autoplay = {
            delay: 0,
            reverseDirection: swiperCarousel.dataset.slider_autoplay_direction === 'reverse',
        }
        options.loop = true
        options.speed = 4000

        if (swiperCarousel.dataset.slider_autoplay_delay) {
            options.autoplay.delay = parseInt(swiperCarousel.dataset.slider_autoplay_delay, 10)
            options.speed = 300
        }
    }

    if (swiperCarousel.dataset.fade === 'true') {
        options.modules.push(EffectFade)
        options.effect = 'fade'
        options.fadeEffect = { crossFade: true }
    }

    return options
}

function setupMobileOnlySwiper(swiperCarousel) {
    const breakpoint = parseInt(swiperCarousel.dataset.slider_mobile_breakpoint, 10) || 768
    const mediaQuery = window.matchMedia(`(max-width: ${breakpoint - 1}px)`)

    const wrapper = swiperCarousel.firstElementChild
    if (!wrapper) return
    const slides = Array.from(wrapper.children)

    const addSwiperClasses = () => {
        wrapper.classList.add('swiper-wrapper')
        slides.forEach((slide) => slide.classList.add('swiper-slide'))
    }

    const removeSwiperClasses = () => {
        wrapper.classList.remove('swiper-wrapper')
        slides.forEach((slide) => slide.classList.remove('swiper-slide'))
    }

    const sync = () => {
        if (mediaQuery.matches) {
            if (!swiperCarousel.swiper) {
                addSwiperClasses()
                swiperCarousel.swiper = new Swiper(swiperCarousel, buildOptions(swiperCarousel))
            }
        } else {
            if (swiperCarousel.swiper) {
                swiperCarousel.swiper.destroy(true, true)
                swiperCarousel.swiper = null
            }
            removeSwiperClasses()
        }
    }

    sync()
    mediaQuery.addEventListener('change', sync)
}

async function initSwiperCarousels() {
    const swiperCarousels = document.querySelectorAll('.swiper-carousel')

    // Ingen slider på sidan = Swiper-chunken hämtas aldrig.
    if (!swiperCarousels.length) return

    ;({ Swiper, Navigation, Scrollbar, Autoplay, EffectFade } = await loadSwiper())

    swiperCarousels.forEach((swiperCarousel) => {
        if (swiperCarousel.dataset.slider_mobile_only === 'true') {
            setupMobileOnlySwiper(swiperCarousel)
            return
        }

        swiperCarousel.swiper = new Swiper(swiperCarousel, buildOptions(swiperCarousel))
    })
}

initSwiperCarousels()
